import { Controller } from '@hotwired/stimulus';
import { app } from '../bootstrap';

/**
 * Loads the regional domain notice via API (avoids embedding it in cached HTML).
 * Skips the request when the dismiss cookie for the current scenario is already set.
 */
export default class extends Controller {
  static values = {
    url: String,
    cookieName: String,
    dismissScenario: String,
  };

  connect() {
    if (this.element.dataset.geoRegionalNoticeLoaded === '1') {
      return;
    }

    if (this.isDismissed()) {
      return;
    }

    this.fetchAndMount();
  }

  isDismissed() {
    const cookieName = this.cookieNameValue;
    const scenario = this.dismissScenarioValue;

    if (!cookieName || !scenario) {
      return false;
    }

    return this.getCookie(cookieName) === scenario;
  }

  getCookie(name) {
    const encoded = encodeURIComponent(name);
    const parts = document.cookie.split(';');

    for (const part of parts) {
      const trimmed = part.trim();
      if (!trimmed.startsWith(`${encoded}=`) && !trimmed.startsWith(`${name}=`)) {
        continue;
      }

      const value = trimmed.slice(trimmed.indexOf('=') + 1);

      try {
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    }

    return null;
  }

  async fetchAndMount() {
    try {
      const response = await fetch(this.urlValue, {
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (response.status === 204 || !response.ok) {
        return;
      }

      const html = await response.text();
      if (html.trim() === '') {
        return;
      }

      this.element.insertAdjacentHTML('beforeend', html);
      this.element.dataset.geoRegionalNoticeLoaded = '1';
      app.load(this.element);
    } catch {
      // Geolocation hint is non-critical; fail silently.
    }
  }
}
